"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInterviewAnswerTextProperty = exports.interviewAnswerTextPropertyDefinition = void 0;
exports.interviewAnswerTextPropertyDefinition = {
    view: { label: 'Answer' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
    ],
    type: 'rich-text',
    multiple: false,
    name: 'interview-answer-text',
};
const isInterviewAnswerTextProperty = (prop) => {
    return prop.name === exports.interviewAnswerTextPropertyDefinition.name;
};
exports.isInterviewAnswerTextProperty = isInterviewAnswerTextProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW50ZXJ2aWV3LWFuc3dlci10ZXh0LnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvaW50ZXJ2aWV3LWFuc3dlci10ZXh0LnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEscUNBQXFDLEdBQUc7SUFDbkQsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLFFBQVEsRUFBRTtJQUN6QixXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxJQUFJO1NBQ2Y7S0FDRjtJQUNELElBQUksRUFBRSxXQUFXO0lBQ2pCLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLHVCQUF1QjtDQUNFLENBQUE7QUFJMUIsTUFBTSw2QkFBNkIsR0FBRyxDQUFDLElBQWtCLEVBQXVDLEVBQUU7SUFDdkcsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLDZDQUFxQyxDQUFDLElBQUksQ0FBQTtBQUNqRSxDQUFDLENBQUE7QUFGWSxRQUFBLDZCQUE2QixpQ0FFekMifQ==